/**

@module

## Anatomy

```jsx
import { DropIndicator } from 'prosekit/react/drop-indicator'

<DropIndicator />
```
*/

'use client'

export * from './index.gen.ts'
